import qs from 'qs';

/**
 * @mixin mixin/inquiry
 * @desc 문의하기 mixin
 * @vue-data {String} category=null - 카테고리
 * @vue-data {String} name=null - 이름
 * @vue-data {String} email=null - 이메일
 * @vue-data {String} question=null - 문의 내용
 * @vue-data {String} year=Object - 년도
 * @vue-data {String} year.label=2021년 - 년도
 * @vue-data {Number} year.value=0 - 식별 번호
 * @vue-data {String} options=Array - 문의 종류
 * @vue-data {Number} options.value=Number - 식별 번호
 * @vue-data {String} options.label=String - 문의 명
 */
export default {
  data() {
    return {
      category: null,
      name    : null,
      email   : null,
      question: null,
      year    : { label: '2021년',
        value: 0 },
      options: [
        { label: '일반문의',
          value: 1 },
        { label: '영업문의',
          value: 2 },
        { label: '채용문의',
          value: 3 }
      ]
    };
  },
  methods: {
    /**
     * 문의하기 폼 통신
     */
    onSend() {
      const validForm = this.$refs.validFormRef;
      validForm.validate().then((success) => {
        if (!success) {
          this.$fo.focusInvalid(this.$refs.formRef);

          return;
        }

        this.axios
          .post(
            '/api/setInquiry.do',
            qs.stringify({
              category: this.category.value,
              name    : this.name,
              email   : this.email,
              question: this.question
            })
          )
          .then((res) => {
            alert(res.data.message);

            this.$nextTick(() => {
              this.$refs.formRef.reset();
              this.category = this.name = this.email = this.question = null;
            });
          })
          .catch((err) => {
            console.log(err);
          });
      });
    }
  }
};
